import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'default' | 'outline' | 'elevated';
  padding?: 'sm' | 'md' | 'lg';
  header?: React.ReactNode;
  footer?: React.ReactNode;
  headerAction?: React.ReactNode;
  compact?: boolean;
}

const Card: React.FC<CardProps> = ({
  children,
  className = '',
  variant = 'default',
  padding = 'md',
  header,
  footer,
  headerAction,
  compact = false,
}) => {
  const paddingClasses = {
    sm: 'p-3 sm:p-4',
    md: 'p-4 sm:p-6',
    lg: 'p-6 sm:p-8',
  };

  const variantClasses = {
    default: 'bg-white border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition-shadow',
    outline: 'bg-white border-2 border-gray-300 rounded-lg',
    elevated: 'bg-white border border-gray-200 rounded-lg shadow-lg hover:shadow-xl transition-shadow',
  };

  return (
    <div className={`${variantClasses[variant]} ${className}`}>
      {(header || headerAction) && (
        <div className={`flex justify-between items-start ${!compact ? 'px-6 pt-6' : 'px-4 pt-4'}`}>
          <div>{header}</div>
          {headerAction && <div>{headerAction}</div>}
        </div>
      )}

      <div className={compact && header ? `${paddingClasses[padding]} pt-2` : paddingClasses[padding]}>
        {children}
      </div>

      {footer && (
        <div className={`border-t border-gray-200 bg-gray-50 ${!compact ? 'px-6 py-4' : 'px-4 py-3'}`}>
          {footer}
        </div>
      )}
    </div>
  );
};

export default Card;
